import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { MessageBubbleProps } from "models/propTypes/messagePropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Tooltip, Grid, Button } from "@mui/material";
import Icon from "../icon";
//#endregion
import { CSSHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const MessageBubble: React.FC<MessageBubbleProps> = (props) => {
  const { message, type, placement, header } = props;
  const [open, setOpen] = React.useState(message !== undefined);

  const messageBubbleDivRef = React.useRef<any>(null);
  const customContainer = messageBubbleDivRef?.current?.closest("#dialogRoot");

  React.useEffect(() => {
    setOpen(message !== undefined);
  }, [message, type]);

  const onClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setOpen(false);
    props.onClose?.();
  };

  return (
    <Tooltip
      id="messageBubble"
      open={open}
      arrow
      placement={placement}
      title={
        message ? (
          <div>
            <Grid container direction="row" flexWrap="nowrap">
              <Grid item xs>
                <Grid item className={cssExports.messageBubbleHeader}>
                  {header}
                </Grid>
                <Grid item>
                  {typeof message == "string" ? <span dangerouslySetInnerHTML={{ __html: message }} /> : message}
                </Grid>
              </Grid>
              {!props.hideClose && type !== StyleEnums.DisplayType.Danger ? (
                <Grid item>
                  <Button onClick={onClose} className={cssExports.messageCloseButton}>
                    <Icon icon={IconDefinitionConstants.WTimesThin} />
                  </Button>
                </Grid>
              ) : (
                <></>
              )}
            </Grid>
          </div>
        ) : (
          ""
        )
      }
      classes={{
        tooltip: clsx(cssExports.messageBubble, CSSHelper.getClassByDisplayType(type), props.className ?? ""),
        tooltipPlacementRight: cssExports.messageBubbleRight,
        tooltipPlacementTop: cssExports.messageBubbleTop,
        tooltipPlacementBottom: cssExports.messageBubbleBottom,
        // In body it has to clear the app's 1700 layers (footer, creation layout), as body-level tooltips do.
        popper: clsx(cssExports.messageBubblePopper, props.portalToBody && cssExports.tooltipPopper),
      }}
      PopperProps={{
        disablePortal: !props.portalToBody && customContainer === null,
        container: props.portalToBody ? undefined : customContainer,
        popperOptions: props.portalToBody ? { strategy: "fixed" } : undefined,
        modifiers: [
          {
            name: "flip",
            options: { enabled: false },
          },
          {
            name: "preventOverflow",
            options: { altBoundary: true },
          },
        ],
      }}
    >
      <Grid ref={messageBubbleDivRef} item container className={cssExports.messageBubbleContentContainer}>
        {props.children}
      </Grid>
    </Tooltip>
  );
};

export default MessageBubble;
